import { Plain, Rich } from '@agendor/shared';

/** Positive if date is in the future, negative if in the past */
export function daysFromToday(date: Plain.SimpleDate): number {
    const today = new Rich.SimpleDate(new Date());
    return today.daysUntil(date);
}
